import moment from "moment";
import { isArray } from "underscore";

/**
 * @typedef {import('moment-timezone').Moment} Moment
 */

/**
 * Get last possible date from options
 *
 * @param {Moment} targetDate
 * @param {Object|array} options
 * @returns {Moment}
 */
export function getLastPossibleDateFromOptions(targetDate, options) {
    if (isArray(options)) {
        return getLastPossibleDateFromOptionsArray(targetDate, options);
    }
    let loopCap = 0;
    while (
        (typeof options[targetDate.format("YYYY-MM-DD")] === "undefined" ||
            options[targetDate.format("YYYY-MM-DD")].disabled === true) &&
        loopCap < 10
    ) {
        targetDate = targetDate.subtract(1, "days");
        loopCap++;
    }
    return targetDate;
}

/**
 * Get last possible date from options
 *
 * @param {Moment} targetDate
 * @param {array} options
 * @returns {Moment}
 */
export function getLastPossibleDateFromOptionsArray(targetDate, optionsArray) {
    let loopCap = 0;
    while (
        !optionsArray.includes(targetDate.format("YYYY-MM-DD")) &&
        loopCap < 10
    ) {
        targetDate = targetDate.subtract(1, "days");
        loopCap++;
    }
    return targetDate;
}

/**
 *
 * @param {?number} day
 * @param {?Moment} startDate
 * @param {?array} optionsArray
 * @returns {Moment}
 */
export function getLastXDateOfMonth(
    day = null,
    startDate = null,
    optionsArray = null
) {
    if (startDate == null) {
        startDate = moment();
    }
    // Monday - 1, Sunday - 7
    let daysToCheck = [];
    if (day == null) {
        // Assume working days
        daysToCheck = [1, 2, 3, 4, 5];
    } else {
        daysToCheck = [day];
    }
    let date = startDate.endOf("month");
    while (
        !daysToCheck.includes(date.isoWeekday()) &&
        (optionsArray === null ||
            !optionsArray.includes(date.format("YYYY-MM-DD")))
    ) {
        date = date.subtract(1, "days");
    }
    let loopCap = 0;
    while (moment().isSameOrAfter(date, "day") && loopCap < 5) {
        date = this.getLastXDateOfMonth(day, startDate.add(1, "months"));
        loopCap++;
    }
    return date;
}